import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IApproverList } from '../../../scripts/approvers';

@Component({
  selector: 'app-modal-content-approver-select',
  templateUrl: './modal-content-approver-select.component.html',
  styleUrl: './modal-content-approver-select.component.css',
  standalone: false,
})
export class ModalContentApproverSelectComponent implements OnInit {
  @Input() approvers: IApproverList[] = [];
  @Output() public readonly closed = new EventEmitter<IApproverList>();

  visibleShop: IApproverList[] = [];

  numFilter = '';
  ccFilter = '';
  nameFilter = '';

  private localApproversCopy: IApproverList[] = [];

  ngOnInit(): void {
    //make a copy of the data and re-map it so that we can show the secondary piece of info. This is the object we will reset to when filtering
    this.localApproversCopy = this.approvers.map((app) => {
      return {
        ...app,
        displaySecondary: app.value,
      };
    });
    this.visibleShop = this.localApproversCopy;
  }

  select(approver: IApproverList) {
    this.closed.emit(approver);
  }

  filterByNumber(filterVal: string): void {
    this.ccFilter = '';
    this.nameFilter = '';
    const normalizedValue = filterVal.toLowerCase().trim();
    if (normalizedValue === '') {
      this.visibleShop = this.localApproversCopy;
    } else {
      this.visibleShop = this.localApproversCopy.filter((x) => x.value.toLowerCase().trim().includes(normalizedValue));
    }
  }

  filterByCC(filterVal: string): void {
    this.numFilter = '';
    this.nameFilter = '';
    const normalizedVal = filterVal.toLowerCase().trim();
    if (normalizedVal === '') {
      this.visibleShop = this.localApproversCopy;
    } else {
      this.visibleShop = this.localApproversCopy.filter((x) =>
        x.costCenters.some((cc) => cc.toLowerCase().trim().includes(normalizedVal)),
      );
    }
  }

  filterByName(filterVal: string): void {
    this.numFilter = '';
    this.ccFilter = '';
    const normalizedValue = filterVal.toLowerCase().trim();
    if (normalizedValue === '') {
      this.visibleShop = this.localApproversCopy;
    } else {
      this.visibleShop = this.localApproversCopy.filter((x) => x.display.toLowerCase().trim().includes(normalizedValue));
    }
  }
}
